<div class="card block isMinimizable"
     [class.minimize]="startMinimized"
     [stepContent]="simulatorStepContent"
     joyrideStep="simulatorStep">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Simulateur de négociation</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/travaux.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-12">
                <div class="data_moy pb-0">
                    <div class="row">
                        <div class="col-6 {{ favorite.lots.length <= 1 ? 'col-md-6' : 'col-md-3'}} text-center indicateur">
                            <label>
                                Total du projet
                                <i class="fa fa-question-circle"
                                   matTooltip="Prix frais de notaire et travaux inclus"></i>
                            </label>
                            <b class="value">
                                {{ backupFavorite.price + backupFavorite.notary_price + backupFavorite.works_total  | number:'1.0-0' }}
                                <span class="unit">€</span>
                            </b>
                        </div>
                        <div class="col-6 {{ favorite.lots.length <= 1 ? 'col-md-6' : 'col-md-3'}} text-center indicateur">
                            <label>
                                Prix au m²
                            </label>
                            <b class="value">
                                {{ (backupFavorite.price + backupFavorite.notary_price + backupFavorite.works_total) / backupFavorite.square | number:'1.1-1' }}
                                <span class="unit">€</span>
                            </b>
                        </div>
                        <div class="col-md-3 col-6 text-center indicateur" [hidden]="favorite.lots.length <= 1">
                            <label>Total des loyers</label>
                            <b class="value">
                                {{ backupFavorite.amount_rent  | number:'1.0-0' }} <span class="unit">€</span>
                            </b>
                        </div>
                        <div class="col-md-3 col-6 text-center indicateur" [hidden]="favorite.lots.length <= 1">
                            <label>Total des travaux</label>
                            <b class="value">
                                {{ backupFavorite.works_total  | number:'1.0-0' }} <span class="unit">€</span>
                            </b>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Prix d'achat
                        <span [hidden]="favorite.price == backupFavorite.price"
                              [ngClass]="{'text-green': favorite.price > backupFavorite.price, 'text-red': favorite.price < backupFavorite.price}">
                                 &nbsp;
                                ({{ (favorite.price - backupFavorite.price) / favorite.price * -100 | number:'1.0-1' }}
                            %)
                       </span>
                        <i class="fa fa-info-circle" matTooltip="Hors frais de notaire"></i></mat-label>
                    <input matInput type="number" step="1000" [(ngModel)]="backupFavorite.price"
                           (ngModelChange)="edit('price')">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Rendement brut</mat-label>
                    <input matInput type="number" step="0.5" [(ngModel)]="backupFavorite.efficiency_brut"
                           (ngModelChange)="updateEfficiency()">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Cash-flow</mat-label>
                    <input matInput type="number" step="10" [(ngModel)]="backupFavorite.cash_flow"
                           (ngModelChange)="updateCashflow()">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Rendement net</mat-label>
                    <input matInput type="number" step="0.5" [(ngModel)]="backupFavorite.efficiency_net"
                           (ngModelChange)="updateEfficiencyNet()">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="col-md-6" [hidden]="favorite.lots.length > 1">
                <mat-form-field>
                    <mat-label>Loyers</mat-label>
                    <input matInput type="number" step="10" [(ngModel)]="backupFavorite.amount_rent"
                           (ngModelChange)="edit()">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-md-6" [hidden]="favorite.lots.length > 1">
                <mat-form-field>
                    <mat-label>Travaux</mat-label>
                    <input matInput type="number" step="1000" [(ngModel)]="backupFavorite.works_total"
                           (ngModelChange)="edit('works_total')">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div [hidden]="backupFavorite.lots.length <= 1" *ngFor="let lot of backupFavorite.lots; index as i;"
                 class="col-md-12">
                <div class="bg-light p-3 pb-0 rounded mb-3">
                    <div class="row">
                        <h3 class="col-md-12 mt-0">
                            {{ lot.title != '' ? lot.title : "Lot " + i }}
                            <span>{{ lot.estate_type }} de {{ lot.square }} m²
                                <ng-container *ngIf="lot.rooms > 0 && (lot.estate_type == 'Maison' || lot.estate_type == 'Appartement')"> - {{ lot.rooms }} pièces</ng-container></span>
                        </h3>
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Loyer</mat-label>
                                <input matInput type="number" step="10" [(ngModel)]="backupFavorite.lots[i].amount_rent"
                                       (ngModelChange)="edit()">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Travaux</mat-label>
                                <input matInput type="number" step="10" [(ngModel)]="lot.works_total"
                                       (ngModelChange)="editLot(i, 'works_total')">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <button type="button" (click)="onNoClick()" class="btn btn-outline w-100 mb-3 mb-md-0">
                    Réinitialiser
                </button>
            </div>
            <div class="col-md-6">
                <button type="button" (click)="onYesClick()" class="btn btn-primary w-100">
                    Appliquer à mon projet
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #simulatorStepContent>
    <div class="user_onboarding_content">
        <h2>Simulateur de négociation</h2>
        <p>
            Vous ne savez pas à quel prix vous devez faire votre offre d’achat ? Ce <b>simulateur de négociation</b> est
            fait pour vous.<br/>
            <br/>
            Vous pouvez mettre un objectif de rendement (brut ou net) et le simulateur vous donnera <b>le prix auquel
            vous devez acheter</b> pour atteindre ce rendement.
        </p>
    </div>
</ng-template>
